import { ProfilePage, UsersPermissionsUserEntity, UsersPermissionsUserInput } from '@/graphql/generated/graphql';
import uploadFile from '@/services/files/upload.service';
import { getPage, getUserById, updatePassword, updateUser } from '@/services/profile/profile.service';
import { create } from 'zustand';

interface ProfileStore {
  user: UsersPermissionsUserEntity;
  page: ProfilePage;
  onInit: (userId: string) => void;
  onUpdateInfo: (userInput: UserProfileInfo) => Promise<void>;
  onUpdatePassword: ({
    currentPassword,
    password,
    passwordConfirmation,
  }: {
    currentPassword: string;
    password: string;
    passwordConfirmation: string;
  }) => Promise<{
    error: string | undefined;
  }>;
}

interface UserProfileInfo {
  location: string;
  surname: string;
  forename: string;
  profile: string;
  photo: File;
}

export const useProfileStore = create<ProfileStore>()((set, get) => ({
  user: {} as UsersPermissionsUserEntity,
  page: {} as ProfilePage,
  onInit: async (userId: string) => {
    const user = await getUserById(userId);
    const { page } = await getPage();
    set({ user: user.user as UsersPermissionsUserEntity, page: page });
  },
  onUpdateInfo: async (userInput: UserProfileInfo) => {
    if (userInput.photo) {
      const { data: uploadResponse } = await uploadFile(userInput.photo);
      userInput.photo = uploadResponse?.[0]?.id;
    }

    const { error } = await updateUser(get().user.id!, userInput as unknown as UsersPermissionsUserInput);
    if (error) {
      throw new Error(error);
    }
  },
  onUpdatePassword: async ({
    currentPassword,
    password,
    passwordConfirmation,
  }: {
    currentPassword: string;
    password: string;
    passwordConfirmation: string;
  }) => {
    const { error } = await updatePassword({ currentPassword, password, passwordConfirmation });
    return { error };
  },
}));
